import he from 'he';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export function EventListSwiper(props) {
    const today = new Date();
    const todayYmd = today.getFullYear().toString() +
        String(today.getMonth() + 1).padStart(2, '0') +
        String(today.getDate()).padStart(2, '0');
    //
    const filteredEvents = props.eventList
        .filter(event => {
            const date = event.acf.event_date;
            //
            return (
                date >= todayYmd
            );
        })
    //
    return (
        <>
            {filteredEvents.length === 0 ? (
                <p>
                    There are currently no events scheduled at the Rum Bar. Please check again later.
                </p>
            ) : (
                <div className="swiper-container">
                    <Swiper
                        modules={[Navigation, Pagination]}
                        slidesPerView={3}
                        slidesPerGroup={1}
                        spaceBetween={0}
                        navigation={{
                            prevEl: '.swiper-prev',
                            nextEl: '.swiper-next',
                        }}
                        pagination={{ clickable: true }}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                            },
                            576: {
                                slidesPerView: 2,
                            },
                            782: {
                                slidesPerView: 3,
                            },
                        }}
                    >
                        {filteredEvents.map(event => {
                            const date = event.acf.event_date;
                            const day = parseInt(date.substring(6, 8), 10);
                            const monthNames = [
                                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                            ];
                            const monthIndex = parseInt(date.substring(4, 6), 10) - 1; // JS months are 0-based
                            const monthName = monthNames[monthIndex];
                            //
                            const featuredMedia = event._embedded?.['wp:featuredmedia']?.[0];
                            const sizesData = featuredMedia?.media_details?.sizes;
                            //
                            const imgSrc =
                                sizesData?.large?.source_url ||
                                sizesData?.medium_large?.source_url ||
                                sizesData?.medium?.source_url;
                            //
                            // Build srcSet dynamically from available sizes
                            const imgSrcSet = sizesData
                                ? Object.values(sizesData)
                                    .map(size => `${size.source_url} ${size.width}w`)
                                    .join(", ")
                                : null;
                            //
                            // Build sizes attribute for Bootstrap responsive layout
                            // xs: 100% width, sm: 50% width, md+: 33.33% width
                            const imgSizes = `
                                (max-width: 575.98px) 100vw,
                                (max-width: 781.98px) 50vw,
                                33.33vw
                            `.replace(/\s+/g, ' ').trim(); // clean whitespace
                            //
                            return (
                                <>
                                    <SwiperSlide>
                                        <div className="swiper-slide-wrapper">
                                            <a href={event.link} className="text-decoration-none text-reset">
                                                <div className="position-relative d-flex">
                                                    {imgSrc && (
                                                        <img
                                                            src={imgSrc}
                                                            srcSet={imgSrcSet || undefined}
                                                            sizes={imgSizes}
                                                            alt={he.decode(event.title.rendered)}
                                                        />
                                                    )}
                                                    <div className="position-relative p-4 text-start d-flex flex-column">
                                                        <p className="mb-auto">{day} <span>{monthName}</span></p>
                                                        <h3 className="mb-3">{he.decode(event.title.rendered)} <span>{he.decode(event.acf.music_set_type)}</span></h3>
                                                        <button><i className="fa fa-arrow-right"></i></button>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </SwiperSlide>
                                </>
                            )
                        })}
                    </Swiper>
                    <button className="swiper-prev"><i className="fa fa-arrow-left"><span className="visually-hidden">Previous Event</span></i></button>
                    <button className="swiper-next"><i className="fa fa-arrow-right"><span className="visually-hidden">Next Event</span></i></button>
                </div>
            )}
        </>
    )
}